import { api } from '@api'
import type { Database } from '@hvf/contracts'

export type GoReadPostRow = Database['public']['Functions']['get_go_read_posts']['Returns'][number]

export const getGoReadPosts = async (): Promise<GoReadPostRow[]> => {
	const { data, error } = await api().rpc('get_go_read_posts')

	if (error) throw new Error(error.message)
	return data ?? []
}

export const deleteGoReadPost = async (id: string) => {
	const { error } = await api().from('go_read_posts').delete().eq('id', id)

	if (error) throw new Error(error.message)
	return true
}
